import {
  SET_SOCIAL_SECURITY_TAXES,
  SET_MEDICARE_TAXES,
  SET_GROWTH_RATE,
  SET_STATE_TAXES,
  SET_FEDERAL_TAXES
} from "./mutations";

const setSocialSecurityTaxes = (payload) => ({
  type: SET_SOCIAL_SECURITY_TAXES,
  payload,
});

const setMedicareTaxes = (payload) => ({
  type: SET_MEDICARE_TAXES,
  payload,
});

const setGrowthRate = (payload) => ({
  type: SET_GROWTH_RATE,
  payload,
});

const setStateTaxes = (payload) => ({
  type: SET_STATE_TAXES,
  payload,
});

const setFederalTaxes = (payload) => ({
  type: SET_FEDERAL_TAXES,
  payload,
});

export { setSocialSecurityTaxes, setMedicareTaxes, setGrowthRate, setStateTaxes, setFederalTaxes };
